import store from 'redux/store';
import { status } from 'constants/general';
import hideElements from 'configs/hideElements';
import { setContext, fetchStaticData, fetchCompanyProfilesList } from 'modules/common/actions';

const initApp = context => {
  store.dispatch(setContext(context));

  if (
    store?.getState()?.common?.staticData.status === status.SHOULD_CALL_API &&
    hideElements.contextsThatDontRequireStaticData.includes(context) === false
  ) {
    const body = {
      data: {
        includeCountries: true,
        includeNationalities: true,
      },
    };
    store.dispatch(fetchStaticData(body));
  }

  if (
    store?.getState()?.common?.companyProfilesList.status === status.SHOULD_CALL_API &&
    hideElements.contextsThatDontRequireCompanyProfileData.includes(context) === false
  ) {
    const body = {
      data: {
        isSelfManaged: false,
        page: 1,
        pageSize: 12,
      },
    };
    store.dispatch(fetchCompanyProfilesList(body));
  }
};

export default initApp;
